const isPlainObject = obj =>
    Object.prototype.toString.call(obj) === '[object Object]' ||
    Object.prototype.toString.call(obj) === '[object Array]';

export default isPlainObject;
